import type { DialpadGridProps } from './index.types';
import { KeypadButton } from 'Modules/softphone/components/SoftphoneKeypad/KeypadGrid/KeypadButton';
import { DIGIT_GRID, DIGIT_LABELS } from 'Modules/softphone/constants';
import React from 'react';

/**
 * DialpadGrid Component
 * 3x4 grid of dialpad buttons for pre-call number entry.
 * Receives onDigitPress from the parent to avoid duplicate hook effects.
 */
export const DialpadGrid = ({
  testID,
  className,
  onDigitPress,
}: DialpadGridProps): React.ReactElement => {
  const dialpadGridTestId = testID ? `${testID}-dialpad-grid` : "dialpad-grid";

  return (
    <div
      id="dialpad-grid"
      className={className}
      role="group"
      aria-label="Dialpad buttons"
      data-testid={dialpadGridTestId}
    >
      {DIGIT_GRID?.map((row) =>
        row.map((digit) => (
          <KeypadButton
            key={digit}
            digit={digit}
            label={DIGIT_LABELS[digit]}
            onClick={onDigitPress}
            testID={`${dialpadGridTestId}-digit-${digit}`}
          />
        ))
      )}
    </div>
  );
};
